import { getAccessToken, removeAccessToken } from "./tokenUtils";
import config from '../utils/config';

export default async function loginCheck() {

    const { pathname } = window.location; 
    console.log('=================>pathname', pathname);

    // 本地没有token,且是根路径
    const accessToken = getAccessToken();
    const tokenFlag = ( !accessToken || accessToken === 'undefined' )
    console.log('=================>accessToken', accessToken);
    if (( tokenFlag && pathname === '/') || (tokenFlag && pathname === '/home') || (tokenFlag && pathname === '/momey')) {
        removeAccessToken();
        // removeRefreshToken();
        return;
    }else{
        if(!['/carrierVerification', '/carrierQuo'].includes(pathname)){
            // 有token 跳转到管理页
            window.location.href = `${config.DOMAIN_NAME}/app/workplace`;
            return;
        }
        
    }

}